import React from "react";

const Language = React.createContext({
   lang: 'en',
   changeLang: null
});

export default Language;